import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { backend_url } from "./clientUrl";
import { useAuth } from "./AuthContext";

const stripePromise = loadStripe("pk_test_51PsEseGQe9fJ5R2jcA3xNoUTF41z6YRM1o9vZRTJNijUT3sJkM8TGVPtaMgL9MCBZfGxa2rYnXHx77A5GfRUfAt600odt31RI3");

function Payment() {
  const location = useLocation();
  const { product, address } = location.state || {};
  const {Useraddress,UserselectedProduct} = useAuth()
  console.log('address',Useraddress)
console.log('selected Product',UserselectedProduct)
  const token = localStorage.getItem("accessToken"); 
  const navigate = useNavigate()
  useEffect(() => {
    const initiatePayment = async () => {
      const stripe = await stripePromise;

      // Create a Checkout Session on your backend
      const response = await fetch(`${backend_url}/auth/payment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          product,
          address,
        }),
      });

      // Ensure the response is successful
      if (!response.ok) {
        console.error("Failed to create checkout session", await response.text());
        return;
      }

      const session = await response.json();

      // Check if session.id is available
      if (!session.id) {
        console.error("Session ID not found", session);
        return;
      }

      // Redirect to Stripe Checkout
      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      if (result.error) {
        console.error(result.error.message);
      } else {
        // If payment succeeds, navigate to the Success route
        navigate("/success", { state: { product, address } });
      }
    };
    console.log(product,address)

    if (product) {
      initiatePayment();
    }
  }, [product, address, navigate]);

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold">Processing Payment...</h1>
      <p>If you are not redirected, please try again.</p>
    </div>
  );
}

export default Payment;
